var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "400pt",
    viewBox: "0 -4 400.00878 400",
    width: "400pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m114.351562 391.363281c-3.40625 0-6.582031-1.738281-8.417968-4.613281-1.835938-2.871094-2.082032-6.480469-.65625-9.574219l171.289062-371.332031c2.300782-5.023438 8.234375-7.230469 13.253906-4.933594 5.023438 2.300782 7.230469 8.234375 4.933594 13.253906l-.027344.054688-171.289062 371.332031c-1.632812 3.546875-5.179688 5.816407-9.085938 5.8125zm0 0",
    fill: "#2eca8b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f55d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m92.203125 300.257812c-2.898437.003907-5.652344-1.25-7.550781-3.4375l-82.199219-94.5625c-3.269531-3.761718-3.269531-9.359374 0-13.121093l82.191406-94.5625c3.625-4.167969 9.941407-4.613281 14.113281-.988281 4.167969 3.625 4.609376 9.941406.984376 14.109374l-76.488282 88 76.488282 88c2.570312 2.957032 3.175781 7.144532 1.554687 10.707032-1.625 3.566406-5.179687 5.851562-9.097656 5.855468zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.804688 300.257812c-3.917969 0-7.472657-2.289062-9.097657-5.855468-1.621093-3.566406-1.015625-7.75 1.554688-10.707032l76.492187-88-76.492187-88c-3.621094-4.167968-3.179688-10.484374.992187-14.109374 4.167969-3.621094 10.484375-3.179688 14.109375.988281l82.191407 94.566406c3.273437 3.761719 3.273437 9.355469 0 13.117187l-82.191407 94.5625c-1.902343 2.191407-4.660156 3.445313-7.558593 3.4375zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.bb04a6f7f32f25434cbf874e457042af.svg";
export { ForwardRef as ReactComponent };